import { BaseFeatureUi } from "../Base/BaseFeatureUi";

export class WebFeatureUiImpl extends BaseFeatureUi {

    isShowExitButton(): boolean {
        return false;
    }
}